import * as React from "react";
import LoginPopup from "../generic/loginPopup";
import DeviceContext from "../../../services/indentifyDevice";
import LeadForm, { ILeadFormProps } from "../forms/leadForm";
import "../../../assets/scss/Login/login/loginScreen/loginScreen.scss";
import "../../../assets/scss/Login/login/forms/leadForm.scss";
// import NuvamaLogo from "../../../assets/new_images/nuvama-logo.svg";
import NuvamaLogo from "../../../assets/new_images/nuvama-logo.svg";

export interface ILeadFormScreenProps extends ILeadFormProps {
  onClose?: () => void;
}

const LeadFormScreen: React.FC<ILeadFormScreenProps> = ({
  onClose,
  ...props
}) => {
  return (
    <LoginPopup
      leftHeaderContent={
        !DeviceContext().isDesktop ? (
          // <span className="edel-icon-edel-logo1 logo1" />
          <img src={NuvamaLogo} alt="nuvama-logo" />
        ) : undefined
      }
      centerHeaderContent={
        DeviceContext().isDesktop ? (
          // <span className="edel-icon-edel-logo1 logo1" />
          <img src={NuvamaLogo} alt="nuvama-logo" />
        ) : undefined
      }
      onClose={onClose}
      className="login_scrn"
    >
      <section className="login_form lead_form">
        <div className="header mg-b30">
          <h1 className="title">
            We Shell get in touch with you to get started
          </h1>
          <p>Quick,Fast and Simple</p>
        </div>

        <LeadForm {...props} />
      </section>
    </LoginPopup>
  );
};

export default LeadFormScreen;
